const RFX_ROUTE = "rfq";

export const rfxDownloadPdfSummaryRoute = (rfxId: number): string => {
	return `${RFX_ROUTE}/${rfxId}/download-summary`;
};

export const rfxDownloadAllResponsesRoute = (rfxId: number): string => {
	return `${RFX_ROUTE}/${rfxId}/download-all-responses`;
};

export const rfxDownloadSingleResponseRoute = (
	rfxId: number,
	companyOrRfqGuestId: number,
	isGuest: boolean
): string => {
	return isGuest
		? `guest/${rfxId}/download-response/${companyOrRfqGuestId}`
		: `rfq/${rfxId}/download-response/${companyOrRfqGuestId}`;
};

export const CancelFileUploadRoute = "file-upload/cancel";
